import React from 'react';
import { getReplacedString } from '../../../../../../helpers/getReplacedString';
import FormWrapper from '../../../common/formComponents/FormWrapper/FormWrapper';
import SelectField from '../../../common/formComponents/SelectField/SelectField';
import { getInputOptions } from '../utils/getInputOptions';

const ChangeHeadOfHouseForm = ({ selectOptions = [], form, initialValue }) => {
  return (
    <FormWrapper>
      <SelectField
        options={getInputOptions({
          initialValue,
          requiredErrMsg: 'Выберите председателя совета дома',
          validationTypes: ['notEqualToInitVal'],
          fieldType: 'number',
          numberComparison: true,
        })}
        selectOptions={selectOptions}
        selectProps={{
          showSearch: true,
          filterOption: (input, option) => {
            const searchText = getReplacedString(option.props.searchtext);
            const value = getReplacedString(input);
            return searchText.includes(value);
          },
        }}
        form={form}
        name="clientId"
        contentKey="content"
        label="Председатель совета дома"
      />
    </FormWrapper>
  );
};

export default ChangeHeadOfHouseForm;
